<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar >
      <!-- <user-menu></user-menu> -->
      <!-- <mobile-menu></mobile-menu> -->
      <template slot-scope="props" slot="links" >
        <span :model="props"></span>
        <sidebar-item
          :link="{name: 'Geral', icon: 'nc-icon nc-chart-pie-36', path: '/app/overview'}"
        ></sidebar-item>
        <sidebar-item
          v-if="permission('access_matriz') || showItem"
          :link="{name: 'Matriz', icon: 'nc-icon nc-atom', path: '/app/matrizes'}"
        ></sidebar-item>
        <sidebar-item
          v-if="permission('access_company')"
          :link="{name: 'Empresa/Filial', icon: 'nc-icon nc-bank', path: '/app/companies'}"
        ></sidebar-item>
        <div v-if="$store.state.general.permission.permissoes_do_usuario.length !== undefined || imachCia || parentCompany">
          <div v-if="$store.state.general.permission.permissoes_do_usuario.length > 0 || imachCia || parentCompany">
            <sidebar-item :link="{name: 'Produtos', icon: 'nc-icon nc-tag-content'}">
              <sidebar-item v-if="permission('access_categories')" :link="{name: 'Categorias', path: '/app/products/categories'}"></sidebar-item>
              <sidebar-item v-if="permission('access_products')" :link="{name: 'Produtos', path: '/app/products/products'}"></sidebar-item>
            </sidebar-item>
            <sidebar-item :link="{name: 'Vending Machines', icon: 'nc-icon nc-cart-simple'}">
              <sidebar-item v-if="permission('access_machine')" :link="{name: 'Máquinas', path: '/app/machines/machines'}"></sidebar-item>
              <sidebar-item v-if="permission('access_lockers')" :link="{name: 'Lockers', path: '/app/machines/lockers'}"></sidebar-item>
              <sidebar-item v-if="permission('access_stock')" :link="{name: 'Estoque', path: '/app/machines/stock'}"></sidebar-item>
              <sidebar-item v-if="permission('access_combos') && showCombo" :link="{name: 'Combos', path: '/app/machines/combos'}"></sidebar-item>
              <sidebar-item v-if="permission('access_movements')" :link="{name: 'Movimentos', path: '/app/machines/movements'}"></sidebar-item>
              <sidebar-item v-if="permission('access_remote')" :link="{name: 'Acionamento remoto', path: '/app/machines/remote/'}"></sidebar-item>
              <sidebar-item v-if="permission('access_videosazonal')" :link="{name: 'Sinalização Digital', path: '/app/machines/videos/'}"></sidebar-item>
              <sidebar-item v-if="permission('access_visualmachine')" :link="{name: 'Visual Machine', path: '/app/visuais'}"></sidebar-item>
              <sidebar-item v-if="$store.state.auth.imach" :link="{name: 'Sincronização', path: '/app/machines/sync'}"></sidebar-item>
              <sidebar-item v-if="$store.state.auth.imach" :link="{name: 'VM requests', path: '/app/machines/requests'}"></sidebar-item>
            </sidebar-item>
            <sidebar-item :link="{name: 'Vendas', icon: 'nc-icon nc-money-coins'}">
              <sidebar-item v-if="permission('access_sells')" :link="{name: 'Vendas', path: '/app/sales/sales'}"></sidebar-item>
              <sidebar-item v-if="permission('access_voucher') && showVoucher" :link="{name: 'Cupons', path: '/app/sales/vouchers'}"></sidebar-item>
              <sidebar-item v-if="permission('access_customers')" :link="{name: 'Clientes', path: '/app/sales/customers'}"></sidebar-item>
            </sidebar-item>
            <sidebar-item
              v-if="permission('access_report')"
              :link="{name: 'Relatório', icon: 'fa fa-download', path: '/app/report'} "
            ></sidebar-item>
            <!-- <sidebar-item :link="{name: 'Vendas', icon: 'nc-icon nc-money-coins'}">
              <sidebar-item :link="{name: 'Clientes', path: '/app/sales/clients'}"></sidebar-item>
              <sidebar-item :link="{name: 'Vendas', path: '/app/sales/sales'}"></sidebar-item>
            </sidebar-item>-->
            <!-- <sidebar-item :link="{name: 'Controle', icon: 'nc-icon nc-preferences-circle-rotate'}">
              <sidebar-item :link="{name: 'Usuários', path: '/app/manage/users'}"></sidebar-item>
              <sidebar-item :link="{name: 'Grupos', path: '/app/manage/groups'}"></sidebar-item>
              <sidebar-item :link="{name: 'Empresas', path: '/app/manage/companies'}"></sidebar-item>
              <sidebar-item :link="{name: 'Tokens', path: '/app/manage/tokens'}"></sidebar-item>
            </sidebar-item>-->
          </div>
        </div>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar @cimach='changeComp'></top-navbar>

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>

      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    UserMenu
  },
  data() {
    return {
      showCombo: false,
      showVoucher: false,
      cont: 0,
      parentCompany: '',
      cia: '',
      imachCia: '',
    }
  },
  created (){},
  mounted() {
    this.$sidebar.toggleMinimize();
    const ciaID = localStorage.getItem('imachCiaID')
    const matriz = localStorage.getItem("parent_company")
    if (matriz) {
      this.showVoucher = true
      this.showCombo = true
    }
    if (ciaID) {
      this.imachCia = Number(ciaID)
      this.$store.dispatch('general/flag', {id: ciaID}).then(()=>{this.featureFlag()
      this.featureFlagVoucher()})
    } else {
      if (this.$store.state.auth.company !== null) {
        this.$store.dispatch('general/flag', {id: this.$store.state.auth.company}).then(()=>{this.featureFlag()
        this.featureFlagVoucher()})
      }
    }
    this.$store.dispatch("general/getPermission")
    console.log('store', this.$store.state)
  },
  computed: {
    showItem() {
      this.parentCompany = localStorage.getItem("parent_company")
      const imach = localStorage.getItem("imach")
      if (imach == 'true') {
        return true
      } else if (localStorage.getItem("parent_company") != 'null') {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    changeComp (result) {
      this.count += 1
      this.cia = result
    },
    permission (permissao) {
      if (this.showItem) {
        return true
      }
      if (this.$store.state.general.permission.permissoes_do_usuario !== undefined) {
        var x = this.$store.state.general.permission.permissoes_do_usuario.filter(el => {
          if (el == permissao) {
            return el
          } 
        })
        if (x.length > 0) {
          return true
        }
        if (this.imachCia) {
          return true
        }
      }
    },
    featureFlag () {
      console.log('feature')
      if (this.$store.state.general.flag !== undefined) {
        const imach = localStorage.getItem("imach")
        if (imach == 'true') {
          console.log('é null')
          this.showCombo = true
        }
        var y = this.$store.state.general.flag.filter(el => {
          if (el.feature === "C01"){
            if (el.active === true) {
              this.showCombo = true
            }
          }
        })
      } else {
        if (this.$store.state.auth.company === "null") {
          console.log('é null')
          this.showCombo = true
        }

      }
    },
    featureFlagVoucher () {
      console.log('feature')
      if (this.$store.state.general.flag !== undefined) {
        if (this.$store.state.auth.company === "null") {
          console.log('é null')
          this.showVoucher = true
        }
        var y = this.$store.state.general.flag.filter(el => {
          if (el.feature === "C03"){
            if (el.active === true) {
              this.showVoucher = true
            }
          }
        })
      } else {
        if (this.$store.state.auth.company === "null") {
          console.log('é null')
          this.showVoucher = true
        }

      }
    },
  }
};
</script>
<style scoped>
.main-panel {
  overflow: hidden;
}
</style>
